import { Role } from '#src/roles.ts'

export type Folder = {
  id: string
  name: string
  roles: Role[]
}

export const BEHAVIORAL_HEALTH_FOLDER_ID = 'behavioral-health'

// `ExtendedDocumentReference.folder` resolves ids through this list, so removing
// or renaming an `id` orphans every document already tagged with it: the document
// reads back as unfiled and loses its folder tag — and its view protection — the
// next time anyone saves it. Change `name` freely; treat `id` as append-only, and
// backfill existing tags before retiring one.
export const FOLDERS: Folder[] = [
  {
    id: BEHAVIORAL_HEALTH_FOLDER_ID,
    name: 'Behavioral Health',
    roles: [Role.SW, Role.PCP, Role.TECH],
  },
]
